
/*
 *
 * PayByLink Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 20-Nov-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_GENERATED_LINKS: '@@PayByLink/get_generated_links',
  DO_GET_GENERATED_LINK_DETAIL: '@@PayByLink/get_generated_link_detail',
  DO_CLEAR_GENERATED_LINK_DETAIL: '@@PayByLink/clear_generated_link_detail',
  DO_GET_SHOPS: '@@PayByLink/get_shops',
  DO_REQUIRE_PBL: '@@PayByLink/require_pbl',
  DO_GENERATE_PBL_LINK: '@@PayByLink/generate_pbl_link',
  DO_GET_SHOPS_INFO: '@@PayByLink/get_shops_info',
  DO_SET_ENTRYPOINT: '@@PayByLink/set_entrypoint',
  DO_GET_SHOPS_AND_TERMINALS: '@@PayByLink/get_shops_and_terminals',
  // @generator action:route:type
  ...createRequestTypes('@@PayByLink', 'GET_GENERATED_LINKS'),
  ...createRequestTypes('@@PayByLink', 'GET_GENERATED_LINK_DETAIL'),
  ...createRequestTypes('@@PayByLink', 'GET_SHOPS'),
  ...createRequestTypes('@@PayByLink', 'REQUIRE_PBL'),
  ...createRequestTypes('@@PayByLink', 'GENERATE_PBL_LINK'),
  ...createRequestTypes('@@PayByLink', 'GET_SHOPS_INFO'),
  ...createRequestTypes('@@PayByLink', 'GET_SHOPS_AND_TERMINALS')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name getShopsAndTerminals
* @return {object} - The action object
*/
export const getShopsAndTerminals = new MakeRequest('PayByLink', 'get_shops_and_terminals')
/** @action request
* * Insert a description
* @name generatePblLink
* @return {object} - The action object
*/
export const generatePblLink = new MakeRequest('PayByLink', 'generate_pbl_link')
/** @action request
* * Insert a description
* @name requirePbl
* @return {object} - The action object
*/
export const requirePbl = new MakeRequest('PayByLink', 'require_pbl')
/** @action request
* * Insert a description
* @name getShops
* @return {object} - The action object
*/
export const getShops = new MakeRequest('PayByLink', 'get_shops')
/** @action request
* * Insert a description
* @name getGeneratedLinks
* @return {object} - The action object
*/
export const getGeneratedLinks = new MakeRequest('PayByLink', 'get_generated_links')
/** @action request
* * Insert a description
* @name getGeneratedLinkDetail
* @return {object} - The action object
*/
export const getGeneratedLinkDetail = new MakeRequest('PayByLink', 'get_generated_link_detail')
/** @action
* * Insert a description
* @name getShopsInfo
* @return {object} - The action object
*/
export const getShopsInfo = new MakeRequest('PayByLink', 'get_shops_info')
// @generator action:route
/** @action
* * Insert a description
* @name GetShopsAndTerminals
* @return {object} - The payload object
*/
export const doGetShopsAndTerminals = payload => createAction(actionTypes.DO_GET_SHOPS_AND_TERMINALS, { payload })
/** @action
* * Insert a description
* @name SetEntrypoint
* @return {object} - The payload object
*/
export const doSetEntrypoint = payload => createAction(actionTypes.DO_SET_ENTRYPOINT, { payload })
/** @action request
* * Insert a description
* @name GetShopsInfo
* @return {object} - The payload object
*/
export const doGetShopsInfo = payload => createAction(actionTypes.DO_GET_SHOPS_INFO, { payload })
/** @action
* * Insert a description
* @name GeneratePblLink
* @return {object} - The payload object
*/
export const doGeneratePblLink = payload => createAction(actionTypes.DO_GENERATE_PBL_LINK, { payload })
/** @action
* * Insert a description
* @name RequirePbl
* @return {object} - The payload object
*/
export const doRequirePbl = payload => createAction(actionTypes.DO_REQUIRE_PBL, { payload })
/** @action
* * Insert a description
* @name GetShops
* @return {object} - The payload object
*/
export const doGetShops = payload => createAction(actionTypes.DO_GET_SHOPS, { payload })
/** @action
* * Insert a description
* @name GetGeneratedLinks
* @return {object} - The payload object
*/
export const doGetGeneratedLinks = payload => createAction(actionTypes.DO_GET_GENERATED_LINKS, { payload })
/** @action
* * Insert a description
* @name GetGeneratedLinkDetail
* @return {object} - The payload object
*/
export const doGetGeneratedLinkDetail = payload => createAction(actionTypes.DO_GET_GENERATED_LINK_DETAIL, { payload })
/** @action
* * Insert a description
* @name ClearGeneratedLinkDetail
* @return {object} - The action object
*/
export const doClearGeneratedLinkDetail = () => createAction(actionTypes.DO_CLEAR_GENERATED_LINK_DETAIL)
